export default __webpack_public_path__ + "static/media/flexline_hd_logo_de.8e74136a.png";